import React, { ChangeEvent, ComponentType, FC } from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import { Radio, IRadioProps } from 'transfix-ui/components/Radio'
import { Box } from 'transfix-ui/core'

type IBaseControllerProps = ControllerProps<ComponentType<IRadioProps>>

export interface IControlledRadioDateTimeCallbackProps
  extends Pick<IBaseControllerProps, 'control' | 'name' | 'defaultValue'> {
  children?: React.ReactNode
}

const ControlledRadioDateTimeCallback: FC<IControlledRadioDateTimeCallbackProps> = ({
  children,
  control,
  defaultValue,
  name,
}) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ onChange, value }) => {
        const changeHandler = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
          onChange(value)
        }

        return (
          <Box mt={1}>
            <Radio
              label='Set a Custom date and time'
              value='yes'
              checked={value === 'yes'}
              onChange={changeHandler}
              dataTest='sd-coverage-form-set-callback'
            />
            <div>{children}</div>
            <Radio
              label='No Callback Required'
              value='no'
              checked={value === 'no'}
              onChange={changeHandler}
              dataTest='sd-coverage-form-no-callback'
            />
          </Box>
        )
      }}
    />
  )
}

export default ControlledRadioDateTimeCallback
